import { MainInput } from "../../components";
import { Formik, Form } from "formik";
import services from '../../../ioc/services';

const EditResponseForm = ({ response }) => {

    return (

        <Formik
            initialValues={response.responseObject ?? {}}
            onSubmit={async (values) => {
                services.api.form.updateResponse(response._id, {
                    responseObject:values
                })
                    .then(res => {
                        services.alert.toast.success("Response Updated Successfuly")
                        window.location.reload();
                    })
                    .catch(err => {
                        services.alert.toast.error(err)
                    })
            }}>
            <Form className=" grid gap-4 mt-4">
                {response.form.fields.map(field =>
                    <MainInput label={field.prompt} name={field.name} />
                )}

                <button type="submit" className=" mt-4 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded">Update Response</button>
            </Form>
        </Formik>

    );


};

export default EditResponseForm;